/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {Type} from 'class-transformer';
import {Dictionary} from 'app/entities/dictionary.entity';
import {SwitchCheckboxCollection} from 'app/entities/switchCollection.entity';
import {FormElementType} from 'app/entities/enums';

export class FormElementCheckbox extends FormElement {
  type: FormElementType = 'checkbox';

  @Type(() => FormElementCheckboxConfiguration)
  configuration: FormElementCheckboxConfiguration = new FormElementCheckboxConfiguration();
}

export class FormElementCheckboxConfiguration extends FormElementConfiguration {
  dictionaryCode?: string = null;
  minSelected?: number = null;
  maxSelected?: number = null;

  @Type(() => Dictionary)
  dictionaryList?: Dictionary[] = [];

  getListCollection?() {
    return new SwitchCheckboxCollection(this.dictionaryList.map((item) => item.getSwitchItem()));
  }
}
